import { render, staticRenderFns } from "./MealWeek.vue?vue&type=template&id=2f9d6faf&"
import script from "./MealWeek.vue?vue&type=script&lang=js&"
export * from "./MealWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports